import { render } from "./ZaikoEpcEventListPage.vue?vue&type=template&id=390abdfc"
import script from "./ZaikoEpcEventListPage.vue?vue&type=script&lang=js"
export * from "./ZaikoEpcEventListPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3094357117/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__